import { SVGIconProps } from '../types/svg';

export const Pin = (props: SVGIconProps) => (
  <svg
    width={51}
    height={51}
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M43.7289 25.6171C43.1557 29.7643 36.2425 38.4147 32.7829 42.5244C31.8661 43.6134 30.1639 43.3781 29.5769 42.0812C27.3618 37.1872 23.0543 26.9859 23.6275 22.8387C24.3948 17.2878 29.5166 13.4099 35.0675 14.1772C40.6183 14.9444 44.4962 20.0663 43.7289 25.6171Z"
      stroke="#00354F"
      strokeLinejoin="round"
    />
    <path
      d="M21.2402 12.3174C21.5624 15.0402 18.847 21.3837 17.1513 25.0182C16.5494 26.3082 14.8458 26.5098 13.9594 25.3959C11.4622 22.2576 7.34118 16.7231 7.01897 14.0003C6.55425 10.0732 9.36106 6.51292 13.2882 6.0482C17.2152 5.58348 20.7755 8.39029 21.2402 12.3174Z"
      stroke="#00354F"
      strokeLinejoin="round"
    />
    <circle
      cx={14.1032}
      cy={12.936}
      r={3.50583}
      transform="rotate(-6.74881 14.1032 12.936)"
      stroke="#FF8A02"
    />
    <circle
      cx={33.7284}
      cy={23.8651}
      r={4.9787}
      transform="rotate(7.86963 33.7284 23.8651)"
      stroke="#278BE5"
      strokeLinecap="round"
    />
  </svg>
);